export default {
  install(Vue) {
    Vue.prototype.$toast = function (message, options = {}) {
      this.$toasted.show(message, options);
    };
  },
};
